import styled from "styled-components";

export const AccountWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    width: 250px;
`;

export const Information = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`;

export const Avatar = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
    margin: 18px;
    border-radius: 50%;
    box-sizing: border-box;
    background-color: #101010;
    box-shadow: 0 0 3px #000000;
    color: #FEFEFE;
    font-size: 60px;
    text-align: center;
    cursor: pointer;
`;

export const ProfileDetails = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0 12px 0 12px;

    & .anticon {
        padding-right: 12px;
        color: #555555;
    }

    & div {
        height: 32px;
        margin: 5px 0px 0px 0px;
    }
`;

export const TenantName = styled.div`
    display: flex;
    align-items: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
`;

export const Name = styled.div`
    display: flex;
    align-items: center;
    font-size: 12px;
`;

export const PhoneNumber = styled.div`
    display: flex;
    align-items: center;
    font-size: 12px;
`;

export const Email = styled.div`
    display: flex;
    align-items: center;
    font-size: 12px;
`;

export const Operations = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    width: 100%;
    margin-top: 12px;
    box-sizing: border-box;
    cursor: pointer;
    border-top: 1px solid #CCCCCC;
`;

export const Operation = styled.div`
    display: flex;
    height: 32px;
    margin: 5px 0px 0px 0px;
    width: 100%;
    flex-direction: row;
    align-items: center;
    user-select: none;
    padding: 0px 12px;
    border-radius: 16px;
    box-sizing: border-box;
    font-size: 12px;

    &:hover {
        background-color: rgba(0, 0, 0, 0.5);
        color: #FFFFFF;
    }
`;

